/** @jsxImportSource @emotion/react */
import { Close } from 'Icons/Icons';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import NavActions from 'Services/Navigation/Actions';

import LOV from 'Lib/LOVs/ShippingAddressLovs';
import ValidationCheck from 'Components/Common/Validation';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    CustomInput,
    Spinner,
    Label,
} from 'reactstrap';

import ErrorMessage from 'Components/Common/ErrorMessage';
import Utils from 'Lib/Utils';

import Selectors from 'Redux/Selectors';
import CustomButton from 'Components/Button';
import DatePicker from 'Components/DatePicker';

// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
import Actions from 'Redux/Actions';

import {
    ContainerAlignCenter,
    leftTitle,
    InputStyle,
    CheckBoxContainer,
    ButtonStyleLeft,
    nestedSignupModalSubmitButton,
    formGroupCss,
    modalWrapper,
    modalSignupWrapper,
    modalContainer,
    datePickerContainer,
    flexHiddenContainer,
    CheckBoxOuterContainerRight,
    CheckBoxContainerRight,
    ForgotPasswordStyle,
    ButtonStyleRight,
    sendEmailModalWrapper,
    modalHeaderContainer,
    checkoutAsGuestButton,
} from './Styles/LoginStyles';

const LoginSignUpModal = (props) => {
    const {
        modal,
        show,
        hide,
        loading,
        onAuthorized,
        signup,
        signingup,
        signupError,
        forgetPasswordLoading,
        forgetPasswordError,
        sendForgetPasswordEmail,
        forgetPasswordEmailSent,
        setIsEmailSent,
        checkOutAsGuest,
        setIsGuest,
    } = props;

    const { error } = props;

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [selectedCountryStates, setselectedCountryStates] = useState([]);
    const [signupFirstName, setSignupFirstName] = useState('');
    const [signupLastName, setSignupLastName] = useState('');
    const [signupEmail, setSignupEmail] = useState('');
    const [signupPassword, setSignupPassword] = useState('');
    const [signupConfirmedPassword, setSignupConfirmedPassword] = useState('');
    const [signupAddress1, setSignupAddress1] = useState('');
    const [signupAddress2, setSignupAddress2] = useState('');
    const [selectedCountry, setSelectedCountry] = useState('Malaysia');
    const [selectedState, setSelectedState] = useState('Selangor');
    const [signupCity, setSignupCity] = useState('');
    const [signupPostcode, setSignupPostcode] = useState('');
    const [signupPhoneNumber, setSignupPhoneNumber] = useState('');
    const [signupSalutation, setSignupSalutation] = useState('');
    const [signupGender, setSignupGender] = useState('Gender');
    const [signupIdNo, setSignupIdNo] = useState('');
    const [signupDateOfBirth, setSignupDateOfBirth] = useState('');
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [signUpBasicError, setSignUpBasicError] = useState('');
    const [signUpValidateError, setSignUpValidateError] = useState('');
    const [loginBasicError, setLoginBasicError] = useState('');

    const [sendEmailModal, setSendEmailModal] = useState(false);
    const [forgetPasswordEmail, setForgetPasswordEmail] = useState('');
    const [forgetPasswordEmailValidateError, setForgetPasswordEmailValidateError] = useState('');
    const [loginModal, setLoginModal] = useState(false);
    const [showSigupModal, setShowSignUpModal] = useState(false);

    const [numberPlaceholder, setNumberPlaceholder] = useState('0123456789');

    useEffect(() => {
        if (selectedCountry) {
            const country = LOV.find(item => item.country === selectedCountry);
            setselectedCountryStates(country?.states);
            setSelectedState(country?.states[0]);
            if (selectedCountry === 'Singapore') {
                setNumberPlaceholder('6512345678');
            } else {
                setNumberPlaceholder('0123456789');
            }
        }
    }, [selectedCountry]);

    const toggleSendEmailModal = () => {
        setIsEmailSent(false);
        setForgetPasswordEmail('');
        setForgetPasswordEmailValidateError('');
        setSendEmailModal(!sendEmailModal);
    };

    const onClosePressed = () => {
        hide();
    };

    const onBackPressed = () => {
        show();
        setShowSignUpModal(false);
    };

    const goToLogin = () => {
        hide();
        setLoginModal(true);
    };

    const goToSignUp = () => {
        show();
        setLoginModal(false);
    };

    const handleSignupClick = () => {
        setSignUpBasicError('');

        const validationError = Utils.Validator.validateSignUpBasic({
            firstName: signupFirstName,
            lastName: signupLastName,
            email: signupEmail,
            password: signupPassword,
            confirmPassword: signupConfirmedPassword,
        });

        if (validationError) {
            setSignUpBasicError(validationError);
        } else if (!agreeTerms) {
            setSignUpBasicError('Please agree to the Terms and Privacy Policy.');
        } else {
            hide();
            setShowSignUpModal(true);
        }
    };

    const afterSignup = () => {
        const country = LOV.find(item => item.country === selectedCountry);

        setShowSignUpModal(false);
        setLoginModal(true);

        setselectedCountryStates(country?.states);
        setSignupFirstName('');
        setSignupLastName('');
        setSignupEmail('');
        setSignupPassword('');
        setSignupConfirmedPassword('');
        setSignupAddress1('');
        setSignupAddress2('');
        setSignupCity('');
        setSelectedState('Selangor');
        setSelectedCountry('Malaysia');
        setSignupPostcode('');
        setSignupPhoneNumber('');
        setSignupIdNo('');
        setSignupSalutation('');
        setSignupGender('');
        setSignupDateOfBirth('');
        setAgreeTerms(false);
        setUsername('');
        setPassword('');
        setSignUpBasicError('');
        setSignUpValidateError('');
    };

    const handleSubmitSignup = () => {
        setSignUpValidateError('');
        setSignUpValidateError('');

        const data = {
            firstName: signupFirstName,
            lastName: signupLastName,
            email: signupEmail,
            password: signupPassword,
            address1: signupAddress1,
            address2: signupAddress2,
            city: signupCity,
            state: selectedState,
            country: selectedCountry,
            postCode: signupPostcode,
            phoneNumber: signupPhoneNumber,
            idNo: signupIdNo,
            salutation: signupSalutation,
            gender: signupGender,
            birthday: signupDateOfBirth,
            onSignup: afterSignup,
        };

        const validationError = Utils.Validator.validateSignUp(data);

        if (validationError) {
            setSignUpValidateError(validationError);
        } else signup(data);
    };

    const handleInputChange = (e, inputField, setInputField) => {
        const { value } = e.target;
        setInputField(value);
    };

    const handleSignUpPasswordChange = (e, inputField, setInputField) => {
        setSignUpBasicError('');

        const { value } = e.target;
        if (value.length <= 5) {
            setSignUpBasicError('Password must be at least 6 characters long.');
        }
        setInputField(value);
    };

    const handleSignUpBasicOnKeyDown = (e) => {
        const { key } = e;
        if (key === 'Enter') handleSignupClick();
    };

    const onLoginPressed = () => {
        const { login } = props;

        if (!username && !password) {
            setLoginBasicError('Please enter Email Address and Password.');
            return;
        } if (!username) {
            setLoginBasicError('Please enter Email Address.');
            return;
        } if (!password) {
            setLoginBasicError('Please enter Password.');
            return;
        }

        login({ username, password, onAuthorized })
            .then((e) => {
                if (e.meta.requestStatus === 'fulfilled') {
                    setIsGuest(false);
                    setLoginModal(false);
                    window.location.reload();
                }
            });
    };

    const renderCountryOptions = () => {
        return LOV.map(item => {
            return (
                <option value={item.country} key={item.country}>{item.country}</option>
            );
        });
    };

    const renderStateOptions = () => {
        return selectedCountryStates?.map(item => {
            return (
                <option value={item} key={item}>{item}</option>
            );
        });
    };

    const handleForgetPasswordClick = () => {
        setLoginModal(false);
        toggleSendEmailModal();
    };

    const handleForgetPasswordBack = () => {
        toggleSendEmailModal();
        hide();
    };

    const closeLoginModal = () => {
        setLoginModal(false);
    };

    const handleSendEmailClick = () => {
        setForgetPasswordEmailValidateError('');
        const emailAddressError = Utils.Validator.validateEmailAddress(forgetPasswordEmail);
        if (emailAddressError) {
            return setForgetPasswordEmailValidateError(emailAddressError);
        } return sendForgetPasswordEmail(forgetPasswordEmail);
    };

    const onCheckOutAsGuest = () => {
        setIsGuest(true);
        NavActions.navToShippingAddress();
    };

    const renderHiddenSignupModal = () => {
        return (
            <Modal
                isOpen={showSigupModal}
                className='modal-dialog-centered modal-lg'
                css={modalSignupWrapper}
            >
                <div css={modalContainer}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <div
                            onClick={onBackPressed}
                            onKeyPress={onBackPressed}
                            role='button'
                            tabIndex='0'
                            style={{ width: 'fit-content', display: 'flex', alignItems: 'center', gap: 5 }}
                        >
                            <img src='/assets/icons/BackArrowCircle.svg' alt='back' />
                            <p style={{ margin: 0 }}>Back</p>
                        </div>
                    </div>

                    <Form>
                        <div>
                            <div css={leftTitle}>Create Account</div>
                        </div>

                        <div>
                            <ValidationCheck
                                label='Phone Number'
                                name='phonenumber'
                                placeholder={numberPlaceholder}
                                value={signupPhoneNumber}
                                type='text'
                                css={InputStyle}
                                formGroupCss={formGroupCss}
                                onChange={(e) => {
                                    handleInputChange(e, signupPhoneNumber, setSignupPhoneNumber);
                                }}
                                errorMessage='Invalid phone number, please fill it in correctly.'
                            />
                        </div>

                        <div>
                            <ValidationCheck
                                label='Address 1'
                                name='address1'
                                placeholder='Street line 1'
                                value={signupAddress1}
                                type='text'
                                maxLength={50}
                                css={InputStyle}
                                formGroupCss={formGroupCss}
                                onChange={(e) => handleInputChange(e, signupAddress1, setSignupAddress1)}
                                errorMessage='Please fill in your address correctly'
                            />
                        </div>

                        <ValidationCheck
                            label='Address 2'
                            name='address2'
                            placeholder='Street line 2'
                            value={signupAddress2}
                            type='text'
                            maxLength={50}
                            css={InputStyle}
                            formGroupCss={formGroupCss}
                            onChange={(e) => handleInputChange(e, signupAddress2, setSignupAddress2)}
                            errorMessage='Please fill in your address correctly'
                        />

                        <div css={flexHiddenContainer}>
                            <ValidationCheck
                                type='select'
                                name='country'
                                value={selectedCountry}
                                css={InputStyle}
                                formGroupCss={formGroupCss}
                                onChange={(e) => handleInputChange(e, selectedCountry, setSelectedCountry)}
                                errorMessage='Please select country'
                            >
                                {renderCountryOptions()}
                            </ValidationCheck>

                            <ValidationCheck
                                name='postcode'
                                placeholder='Postcode'
                                value={signupPostcode}
                                type='text'
                                css={InputStyle}
                                formGroupCss={formGroupCss}
                                onChange={(e) => handleInputChange(e, signupPostcode, setSignupPostcode)}
                                errorMessage='Invalid Postcode, please fill it in correctly.'
                            />
                        </div>
                        <div css={flexHiddenContainer}>
                            <ValidationCheck
                                name='state'
                                value={selectedState}
                                type='select'
                                css={InputStyle}
                                formGroupCss={formGroupCss}
                                onChange={(e) => handleInputChange(e, selectedState, setSelectedState)}
                                errorMessage='Please select your state'
                            >
                                {renderStateOptions()}
                            </ValidationCheck>
                            <ValidationCheck
                                name='city'
                                placeholder='City'
                                value={signupCity}
                                type='text'
                                css={InputStyle}
                                formGroupCss={formGroupCss}
                                onChange={(e) => handleInputChange(e, signupCity, setSignupCity)}
                                errorMessage='Please enter your city'
                            />
                        </div>
                        <div css={datePickerContainer}>
                            <DatePicker
                                onChange={setSignupDateOfBirth}
                                value={signupDateOfBirth}
                                maxDate={new Date()}
                                placeholder='DD/MM/YY'
                            >
                                <ValidationCheck
                                    label='Date of birth'
                                    placeholder='DD/MM/YY'
                                    type='text'
                                    validationDisabled
                                    css={InputStyle}
                                    formGroupCss={formGroupCss}
                                />
                            </DatePicker>
                        </div>
                        <div>
                            <ValidationCheck
                                label='Gender'
                                name='gender'
                                placeholder='Gender'
                                value={signupGender}
                                type='select'
                                css={InputStyle}
                                formGroupCss={formGroupCss}
                                onChange={(e) => handleInputChange(e, signupGender, setSignupGender)}
                                errorMessage='Please select gender'
                            >
                                <option label='selected gender' value='Gender' selected hidden> </option>
                                <option value='MALE'>MALE</option>
                                <option value='FEMALE'>FEMALE</option>
                            </ValidationCheck>
                        </div>
                    </Form>
                    {/* </ModalBody> */}
                    <ModalFooter style={{ justifyContent: 'center', marginTop: '5px', display: 'flex', flexDirection: 'column' }}>
                        <ErrorMessage error={signupError || signUpValidateError} />
                        {signingup
                            ? <Spinner color='red' style={{ width: 20, height: 20, marginTop: '20px' }} />
                            : (
                                <Button
                                    css={nestedSignupModalSubmitButton}
                                    onClick={handleSubmitSignup}
                                >
                                    Create Account
                                    <img src='/assets/icons/ArrowRight.png' alt='arrow right' />
                                </Button>
                            )}
                    </ModalFooter>
                </div>
            </Modal>
        );
    };

    const renderRequestOtpModal = () => {
        const renderButton = () => {
            if (forgetPasswordEmailSent) {
                return (
                    <div style={{ width: 200, marginLeft: 'auto', marginRight: 'auto' }}>
                        <CustomButton
                            style={{ marginTop: '10px' }}
                            onClick={toggleSendEmailModal}
                            text='OK'
                        />
                    </div>
                );
            }

            return (
                <div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <CustomButton
                        onClick={handleSendEmailClick}
                        disabled={forgetPasswordEmailSent}
                        error={forgetPasswordEmailValidateError || forgetPasswordError}
                        loading={forgetPasswordLoading}
                        text='Send email'
                    />
                </div>
            );
        };

        return (
            <Modal
                isOpen={sendEmailModal}
                // toggle={toggleSendEmailModal}
                size='md'
                css={sendEmailModalWrapper}
            >
                <div>
                    <ModalHeader css={modalHeaderContainer}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <div
                                onClick={handleForgetPasswordBack}
                                onKeyPress={handleForgetPasswordBack}
                                role='button'
                                tabIndex='0'
                                style={{ width: 'fit-content', display: 'flex', alignItems: 'center', gap: 5 }}
                            >
                                <img src='/assets/icons/BackArrowCircle.svg' alt='back' />
                                <p style={{ margin: 0 }}>Back</p>
                            </div>
                        </div>

                        <p className='title'>Reset Password</p>

                        <p className='text'>
                            {'We\'ll'}
                            {' '}
                            email you a link to reset your password
                        </p>
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <ValidationCheck
                                label='Email address'
                                name='email'
                                value={forgetPasswordEmail}
                                type='email'
                                // placeholder='E-mail Address'
                                css={InputStyle}
                                onChange={(e) => handleInputChange(e, forgetPasswordEmail, setForgetPasswordEmail)}
                                formGroupCss={formGroupCss}
                                errorMessage='Invalid email, please fill it in correctly.'
                                disabled={forgetPasswordEmailSent}
                                onKeyDown={(e) => {
                                    const { key } = e;
                                    if (key === 'Enter') handleSendEmailClick();
                                }}
                            />
                        </div>
                        <div>
                            <Label hidden={!forgetPasswordEmailSent}>
                                An email has been sent to
                                {' '}
                                {forgetPasswordEmail}
                            </Label>
                        </div>
                        {renderButton()}
                    </ModalBody>
                </div>
            </Modal>
        );
    };

    const renderSignInModal = () => {
        return (
            <Modal
                isOpen={loginModal}
                className='modal-dialog-centered modal-xl'
                css={modalWrapper}
            >
                <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Close
                            onClick={closeLoginModal}
                            onKeyPress={closeLoginModal}
                            role='button'
                            tabIndex='0'
                        />
                    </div>

                    <div>
                        <div css={leftTitle}>
                            {checkOutAsGuest ? 'Login to Checkout' : 'Login'}
                        </div>
                        <div style={{ display: 'flex', fontSize: '1.4rem', fontFamily: 'AcuminRpro', marginBottom: 10 }}>
                            <p style={{ marginRight: 4 }}>{'Don\'t have an account? '}</p>
                            {' '}
                            <div
                                onClick={goToSignUp}
                                onKeyPress={goToSignUp}
                                role='button'
                                tabIndex='0'
                            >
                                <p style={{ textDecoration: 'underline', color: '#064E72', fontWeight: 700 }}>Register here</p>
                            </div>
                        </div>
                    </div>

                    <Form>
                        <div>
                            <ValidationCheck
                                label='Email address'
                                name='email'
                                value={username}
                                css={InputStyle}
                                onChange={(e) => setUsername(e.target.value.trimStart().trimEnd())}
                                formGroupCss={formGroupCss}
                                errorMessage='Invalid email, please fill it in correctly.'
                            />
                        </div>

                        <div>
                            <ValidationCheck
                                label='Password'
                                name='password'
                                type='password'
                                value={password}
                                css={InputStyle}
                                onChange={(e) => setPassword(e.target.value)}
                                formGroupCss={formGroupCss}
                                errorMessage='Invalid Password'
                            />
                        </div>

                        <div css={ContainerAlignCenter}>
                            <div css={CheckBoxOuterContainerRight}>
                                <div css={CheckBoxContainerRight}>
                                    <CustomInput type='checkbox' id='remember me' />
                                    <div>Remember me</div>
                                </div>
                                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                                <div onClick={handleForgetPasswordClick} onKeyDown={handleForgetPasswordClick} css={ForgotPasswordStyle}>
                                    Forgot password?
                                </div>
                            </div>
                        </div>

                        <div css={ContainerAlignCenter}>
                            <div css={ButtonStyleRight}>
                                <ErrorMessage error={loginBasicError} />
                                <CustomButton
                                    rightArrow
                                    onClick={onLoginPressed}
                                    text='Login'
                                    loading={loading}
                                    error={error}
                                />
                            </div>
                        </div>

                        {checkOutAsGuest
                        && (
                            <>

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10 }}>
                                    <div style={{ flex: 1, border: '1px solid #E6DFD8' }} />
                                    Or
                                    <div style={{ flex: 1, border: '1px solid #E6DFD8' }} />
                                </div>

                                <div style={{ width: '100%' }}>
                                    <Button
                                        onClick={onCheckOutAsGuest}
                                        onKeyPress={onCheckOutAsGuest}
                                        role='button'
                                        tabIndex={0}
                                        css={checkoutAsGuestButton}
                                    >
                                        Checkout as Guest
                                    </Button>
                                </div>
                            </>
                        )}

                    </Form>
                </div>
            </Modal>
        );
    };

    return (
        <>
            <Modal
                isOpen={modal}
                className='modal-dialog-centered modal-xl'
                css={modalWrapper}
            >
                <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Close
                            onClick={onClosePressed}
                            onKeyPress={onClosePressed}
                            role='button'
                            tabIndex='0'
                        />
                    </div>

                    <Form>
                        <div>
                            <div css={leftTitle}>
                                {checkOutAsGuest ? 'New to Tiansi? Register Now' : 'Create Account'}
                            </div>
                            <div style={{ display: 'flex', fontSize: '1.4rem', fontFamily: 'AcuminRpro', marginBottom: 10 }}>
                                <p style={{ marginRight: 4 }}>Already have an account? </p>
                                {' '}
                                <div
                                    onClick={goToLogin}
                                    onKeyPress={goToLogin}
                                    role='button'
                                    tabIndex='0'
                                >
                                    <p style={{ textDecoration: 'underline', color: '#064E72', fontWeight: 700 }}>Login here</p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <ValidationCheck
                                label='First Name'
                                name='firstname'
                                placeholder=''
                                value={signupFirstName}
                                type='text'
                                css={InputStyle}
                                onChange={(e) => handleInputChange(e, signupFirstName, setSignupFirstName)}
                                formGroupCss={formGroupCss}
                                errorMessage='Please fill in first name correctly.'
                            />
                        </div>

                        <div>
                            <ValidationCheck
                                label='Last Name'
                                name='lastname'
                                placeholder=''
                                value={signupLastName}
                                type='text'
                                css={InputStyle}
                                onChange={(e) => handleInputChange(e, signupLastName, setSignupLastName)}
                                formGroupCss={formGroupCss}
                                errorMessage='Please fill in last name correctly.'
                            />
                        </div>

                        <div>
                            <ValidationCheck
                                label='Email'
                                name='email'
                                placeholder=''
                                value={signupEmail}
                                // type='email'
                                css={InputStyle}
                                onChange={(e) => handleInputChange(e, signupEmail, setSignupEmail)}
                                formGroupCss={formGroupCss}
                                errorMessage='Invalid Email, please fill it in correctly.'
                            />
                        </div>

                        <div>
                            <ValidationCheck
                                label='Password'
                                name='password'
                                placeholder=''
                                value={signupPassword}
                                type='password'
                                css={InputStyle}
                                onChange={(e) => handleSignUpPasswordChange(e, signupPassword, setSignupPassword)}
                                formGroupCss={formGroupCss}
                                errorMessage='Please enter password'
                            />
                        </div>

                        <div>
                            <ValidationCheck
                                label='Confirm Password'
                                name='confirmedpassword'
                                placeholder=''
                                value={signupConfirmedPassword}
                                type='password'
                                css={InputStyle}
                                onChange={(e) => handleInputChange(e, signupConfirmedPassword, setSignupConfirmedPassword)}
                                formGroupCss={formGroupCss}
                                errorMessage='Please enter password'
                                onKeyDown={handleSignUpBasicOnKeyDown}
                            />
                        </div>

                        <div css={ContainerAlignCenter}>
                            <div css={CheckBoxContainer}>
                                <CustomInput
                                    type='checkbox'
                                    id='terms'
                                    checked={agreeTerms}
                                    onChange={() => setAgreeTerms(!agreeTerms)}
                                />
                                <div>
                                    I agree to the
                                    <button
                                        type='button'
                                        style={{ color: 'black', marginLeft: 5, border: 0, backgroundColor: 'transparent', textDecorationLine: 'underline' }}
                                        onClick={() => {
                                            window.open(`${process.env.REACT_APP_BASE_URL_OLD}/terms-of-service`, '_blank');
                                        }}
                                    >
                                        Terms & Privacy Policy
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ErrorMessage error={signUpBasicError} style={{ justifyContent: 'center' }} />

                        <div css={ContainerAlignCenter}>
                            <Button
                                css={ButtonStyleLeft}
                                onClick={handleSignupClick}
                            >
                                ㅤ Continue
                                <img className='arrowWhite' src='/assets/icons/ArrowRight.png' alt='arrow right' />
                                <img className='arrowBlue' src='/assets/icons/ArrowRightBlue.svg' alt='arrow right' />
                            </Button>
                        </div>

                        {checkOutAsGuest
                            && (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, marginTop: 40 }}>
                                        <div style={{ flex: 1, border: '1px solid #E6DFD8' }} />
                                        Or
                                        <div style={{ flex: 1, border: '1px solid #E6DFD8' }} />
                                    </div>

                                    <div style={{ width: '100%' }}>
                                        <Button
                                            onClick={onCheckOutAsGuest}
                                            onKeyPress={onCheckOutAsGuest}
                                            role='button'
                                            tabIndex={0}
                                            css={checkoutAsGuestButton}
                                        >
                                            Checkout as Guest
                                        </Button>
                                    </div>
                                </>
                            )}

                    </Form>
                </div>
            </Modal>
            {renderHiddenSignupModal()}
            {renderRequestOtpModal()}
            {renderSignInModal()}
        </>
    );
};

const mapStateToProps = (state) => ({
    loading: Selectors.getAuthLoginAttempting(state),
    error: Selectors.getAuthLoginError(state),
    signingup: Selectors.getAuthSignUpAttempting(state),
    signupError: Selectors.getAuthSignUpError(state),
    forgetPasswordLoading: Selectors.getAuthForgetPasswordAttempting(state),
    forgetPasswordError: Selectors.getAuthForgetPasswordError(state),
    forgetPasswordEmailSent: Selectors.getUiAuthIsEmailSent(state),
});

const mapDispatchToProps = (dispatch) => ({
    login: (params) => dispatch(Actions.authLogin(params)),
    reset: () => dispatch(Actions.authClearLogin()),
    signup: (data) => dispatch(Actions.authSignup({ ...data })),
    setSignUpModalVisible: (modalVisible) => dispatch(Actions.uiSetSignUpModalVisible(modalVisible)),
    sendForgetPasswordEmail: (email) => dispatch(Actions.authForgetPassword({ email })),
    setIsEmailSent: (data) => dispatch(Actions.uiSetIsEmailSent(data)),
    setIsGuest: (data) => dispatch(Actions.cartSetIsGuest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginSignUpModal);
